import Reveal from '@/components/feature/Reveal';
import SectionHeading from './SectionHeading';
import { highlights } from '@/mocks/guide';

export default function Highlights() {
  return (
    <section id="highlights" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="WHY SUBMIT"
          title="为什么值得认真按格式投稿"
          desc="线索被采纳与否，往往不在于事情够不够大，而在于信息够不够清楚、可核实。下面这四点，是爆料51 在处理每一条投稿时都会做的事。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {highlights.map((item, index) => (
            <Reveal key={item.title} delay={index * 90}>
              <article className="h-full p-5 md:p-6 rounded-lg bg-background-100 border border-background-200 transition-colors hover:border-primary-300">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-2xl`} aria-hidden="true" />
                </span>
                <h3 className="mt-4 font-heading font-semibold text-lg text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}